import { STORY } from '../story/data';
import { ASSETS } from '../assetManifest';


export const getGameData = (chapterId) => {
  const chapterData = STORY[chapterId];
  const sceneData = chapterData.scenes[chapterData.firstScene];
  const dialogData = sceneData.lines[0];

  const characters = {};
  
  if (sceneData.characters) {
    if (sceneData.characters.left) {
      characters.left = {
        image: ASSETS.speakers[sceneData.characters.left.speakerId].path,
        shouldAnimate: sceneData.characters.left.entering
      };
    }
    if (sceneData.characters.right) {
      characters.right = {
        image: ASSETS.speakers[sceneData.characters.right.speakerId].path,
        shouldAnimate: sceneData.characters.right.entering
      };
    }
  }

  const info = sceneData.info ? {
    barName: sceneData.info.barName,
    barFill: sceneData.info.barFill,
    timeName: sceneData.info.timeName,
  } : null;

  return {
    backgroundImage: ASSETS.locations[sceneData.locationId].path,
    characters,
    dialog: dialogData,
    fonts: sceneData.fonts,
    info,
    nextDialog: sceneData.lines[1] || null,
    sceneId: sceneData.id
  };
};

export const makeChoice = (app, id, sceneId, choice, onLeaveScene) => {
  const chapterData = STORY[id];
  
  if (choice.nextScene !== undefined) {
    const nextScene = chapterData.scenes[choice.nextScene];
    return {
      ...getGameData(id),
      dialog: nextScene.lines[0],
      nextDialog: nextScene.lines[1] || null,
      sceneId: nextScene.id
    };
  }

  if (choice.exitScene) {
    onLeaveScene?.();
  }
};
